module.exports = __webpack_public_path__ + "img/line_text.4b30ef3e.svg";